<header>
  <!-- mobile -->
  <div class="d-lg-none header-m-wrapper" #toolbar>
    <app-toolbar-menu [isAdmin$]="isAdmin$" [openNavigation]="onMenuBtnClick"></app-toolbar-menu>
  </div>

  <!-- sidebar content template -->
  <ng-template #navigationSidebarContent>
    <app-dashboard-new-menu-hogia [menuItems]="menu" [close]="closeSidebar"></app-dashboard-new-menu-hogia>
  </ng-template>

  <!-- desktop -->
  <div class="d-none d-lg-block left-column">
    <app-dashboard-new-menu-hogia [menuItems]="menu"></app-dashboard-new-menu-hogia>
  </div>
</header>
